module.exports = __webpack_public_path__ + "static/media/Siren.b3463ad3.mp3";